<template>

  <!-- 관리자 -->
  <div class="side_menu_wr">
    <!-- 접속중인 페이지에 해당하는 목록에 current_page 클래스 추가 -->
    <router-link to="/" class="d-flex al-cnt current_page menu_item">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="15.7" height="15.7" viewBox="0 0 15.7 15.7"><path d="M15.4,6.5,11.1,1.6a4.1,4.1,0,0,0-6.2,0L.6,6.5A1.6,1.6,0,0,0,1.8,9.2H2V14c0,.9.6,1.8,2.4,1.8h7.8A1.8,1.8,0,0,0,14,14V9.2h.2a1.6,1.6,0,0,0,1.5-1A1.4,1.4,0,0,0,15.4,6.5ZM6.8,14.6V11a1.2,1.2,0,0,1,2.4,0v3.6ZM14.2,8h-.8l-.4.2a.5.5,0,0,0-.2.4V14a.6.6,0,0,1-.6.6H10.4V11a2.4,2.4,0,0,0-4.8,0v3.6H4.4c-.4,0-1.2,0-1.2-.6V8.6A.6.6,0,0,0,2.6,8H1.8a.4.4,0,0,1-.3-.7l4.3-5A2.9,2.9,0,0,1,8,1.3a2.9,2.9,0,0,1,2.2,1.1l4.3,4.9C14.7,7.6,14.6,8,14.2,8Z" transform="translate(-0.2 -0.2)" style="fill:#fdb913"/></svg>
      <h4>Dashboard</h4>
    </router-link>

    <!--
    <button class="w-100p menu_item">
      <a href="#" class="d-flex al-cnt" @click="openSubMenu(0)">
        <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M12.6,1.6V.9a.8.8,0,0,0-.8-.9.9.9,0,0,0-.8.9v.7H5V.9A.9.9,0,0,0,4.1,0a.9.9,0,0,0-.8.9v.7A3.9,3.9,0,0,0,0,5.5v6.6A3.8,3.8,0,0,0,3.7,16h8.6A3.8,3.8,0,0,0,16,12.1V5.5A3.8,3.8,0,0,0,12.6,1.6Zm1.8,10.5a2.2,2.2,0,0,1-2.1,2.2H3.7a2.2,2.2,0,0,1-2.1-2.2V5.5A2.3,2.3,0,0,1,3.3,3.3v.8a.9.9,0,0,0,.8.8A.9.9,0,0,0,5,4.1V3.3h6v.8a.9.9,0,0,0,.8.8.8.8,0,0,0,.8-.8V3.3a2.3,2.3,0,0,1,1.8,2.2Z" transform="translate(0 0)" style="fill:#fdb913"/><path d="M7.7,11.3l-.6-.2-2-2a.9.9,0,0,1,0-1.2.8.8,0,0,1,1.1,0L7.6,9.3l2.5-2.6a.9.9,0,0,1,1.2,0,.9.9,0,0,1,0,1.2L8.2,11.1Z" transform="translate(0 0)" style="fill:#fdb913"/></svg>
        <h5>스마트룸</h5>

        <i class="xi-angle-down-min"></i>
      </a>
      <ul class="w-100p sub_menu off">
        <li><router-link to="/smartroom">스마트룸 목록</router-link></li>
      </ul>
    </button>

    <button class="w-100p menu_item">
      <a href="#" class="d-flex al-cnt" @click="openSubMenu(1)">
        <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="14.4" viewBox="0 0 16 14.4"><path d="M12.3,15.1H3.7A3.8,3.8,0,0,1,0,11.4V4.5A3.8,3.8,0,0,1,3.7.7h8.6A3.8,3.8,0,0,1,16,4.5v6.9A3.8,3.8,0,0,1,12.3,15.1ZM3.7,2.4A2.1,2.1,0,0,0,1.6,4.5v6.9a2.2,2.2,0,0,0,2.1,2.1h8.6a2.2,2.2,0,0,0,2.1-2.1V4.5a2.1,2.1,0,0,0-2.1-2.1Z" transform="translate(0 -0.7)" style="fill:#fdb913"/><path d="M7.8,6.4H4.1a.8.8,0,0,1-.8-.8.8.8,0,0,1,.8-.9H7.8a.8.8,0,0,1,.8.9A.8.8,0,0,1,7.8,6.4Z" transform="translate(0 -0.7)" style="fill:#fdb913"/><path d="M9.6,9.5H4.1a.8.8,0,0,1-.8-.8.7.7,0,0,1,.8-.8H9.6a.8.8,0,0,1,.8.8A.9.9,0,0,1,9.6,9.5Z" transform="translate(0 -0.7)" style="fill:#fdb913"/></svg>
        <h5>회의</h5>

        <i class="xi-angle-down-min"></i>
      </a>
      <ul class="w-100p sub_menu off">
        <li>회의실 관리</li>
        <li>리뷰관리</li>
      </ul>
    </button>
    -->

    <button class="w-100p menu_item">
      <a href="#" class="d-flex al-cnt" @click="openSubMenu(0)">
        <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M12.6,1.6V.9a.8.8,0,0,0-.8-.9.9.9,0,0,0-.8.9v.7H5V.9A.9.9,0,0,0,4.1,0a.9.9,0,0,0-.8.9v.7A3.9,3.9,0,0,0,0,5.5v6.6A3.8,3.8,0,0,0,3.7,16h8.6A3.8,3.8,0,0,0,16,12.1V5.5A3.8,3.8,0,0,0,12.6,1.6Zm1.8,10.5a2.2,2.2,0,0,1-2.1,2.2H3.7a2.2,2.2,0,0,1-2.1-2.2V5.5A2.3,2.3,0,0,1,3.3,3.3v.8a.9.9,0,0,0,.8.8A.9.9,0,0,0,5,4.1V3.3h6v.8a.9.9,0,0,0,.8.8.8.8,0,0,0,.8-.8V3.3a2.3,2.3,0,0,1,1.8,2.2Z" transform="translate(0 0)" style="fill:#fdb913"/><path d="M7.7,11.3l-.6-.2-2-2a.9.9,0,0,1,0-1.2.8.8,0,0,1,1.1,0L7.6,9.3l2.5-2.6a.9.9,0,0,1,1.2,0,.9.9,0,0,1,0,1.2L8.2,11.1Z" transform="translate(0 0)" style="fill:#fdb913"/></svg>
        <h5> 고객사 / 맴버 관리 </h5>
        <i class="xi-angle-down-min"></i>
      </a>
      <ul class="w-100p sub_menu off">
        <li><router-link to="/company">고객사 관리</router-link></li>
        <!-- <li><router-link to="/member">맴버 관리</router-link></li> -->
      </ul>
    </button>

    <button class="w-100p menu_item">
      <a href="#" class="d-flex al-cnt" @click="openSubMenu(1)">
        <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M12.6,1.6V.9a.8.8,0,0,0-.8-.9.9.9,0,0,0-.8.9v.7H5V.9A.9.9,0,0,0,4.1,0a.9.9,0,0,0-.8.9v.7A3.9,3.9,0,0,0,0,5.5v6.6A3.8,3.8,0,0,0,3.7,16h8.6A3.8,3.8,0,0,0,16,12.1V5.5A3.8,3.8,0,0,0,12.6,1.6Zm1.8,10.5a2.2,2.2,0,0,1-2.1,2.2H3.7a2.2,2.2,0,0,1-2.1-2.2V5.5A2.3,2.3,0,0,1,3.3,3.3v.8a.9.9,0,0,0,.8.8A.9.9,0,0,0,5,4.1V3.3h6v.8a.9.9,0,0,0,.8.8.8.8,0,0,0,.8-.8V3.3a2.3,2.3,0,0,1,1.8,2.2Z" transform="translate(0 0)" style="fill:#fdb913"/><path d="M7.7,11.3l-.6-.2-2-2a.9.9,0,0,1,0-1.2.8.8,0,0,1,1.1,0L7.6,9.3l2.5-2.6a.9.9,0,0,1,1.2,0,.9.9,0,0,1,0,1.2L8.2,11.1Z" transform="translate(0 0)" style="fill:#fdb913"/></svg>
        <h5> 고객사 관리(매니저) </h5>
        <i class="xi-angle-down-min"></i>
      </a>
      <ul class="w-100p sub_menu off">
        <li><router-link :to="{name:'manager'}">전체 고객사</router-link></li>
<!--        <li><router-link :to="{name:'manager_lev', params:{lev: 3}}">신청 고객사(3)</router-link></li>-->
        <li><router-link :to="{name:'manager_lev', params:{lev: 1}}">신청 고객사 (1)</router-link></li>
        <li><router-link :to="{name:'manager_lev', params:{lev: 5}}">승인 고객사 (5)</router-link></li>
      </ul>
    </button>
    <!--
    <a href="" class="d-flex al-cnt">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="10.4" height="15.8" viewBox="0 0 10.4 15.8"><path d="M5,15.9H4.6a.7.7,0,0,1-.4-.7V9.7L1.5,11.5a.8.8,0,0,1-1.1-.2.9.9,0,0,1,.2-1.1L3.9,8,.7,5.8A.8.8,0,0,1,.4,4.7a.9.9,0,0,1,1.1-.2L4.2,6.3V.9A.7.7,0,0,1,4.6.2a.6.6,0,0,1,.8.1l5,3.8a.9.9,0,0,1,.3.7.7.7,0,0,1-.3.6L6.7,7.9l3.6,2.5a.5.5,0,0,1,.4.6.7.7,0,0,1-.3.6L5.5,15.7Zm.7-6.7v4.2l2.9-2.3Zm0-6.7V6.7l2.9-2Z" transform="translate(-0.3 -0.1)" style="fill:#fdb913"/></svg>
      <h5>스마트기기관리</h4>
    </a>

    <a href="" class="d-flex al-cnt">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="15.7" viewBox="0 0 16 15.7"><path d="M8,15.9a1,1,0,0,1-.7-.4L5.8,13H3.7A3.8,3.8,0,0,1,0,9.3V3.9A3.8,3.8,0,0,1,3.7.1h8.6A3.8,3.8,0,0,1,16,3.9V9.3A3.8,3.8,0,0,1,12.3,13H10.2L8.7,15.5a.8.8,0,0,1-.7.4ZM3.7,1.8A2.1,2.1,0,0,0,1.6,3.9V9.3a2.1,2.1,0,0,0,2.1,2H6.2a.8.8,0,0,1,.7.4L8,13.5l1.1-1.8a.8.8,0,0,1,.7-.4h2.5a2.1,2.1,0,0,0,2.1-2V3.9a2.1,2.1,0,0,0-2.1-2.1Z" transform="translate(0 -0.1)" style="fill:#fdb913"/><path d="M5.6,6.6a1,1,0,0,1-2,0,1,1,0,0,1,1-1.1,1,1,0,0,1,1,1.1" transform="translate(0 -0.1)" style="fill:#fdb913"/><path d="M9,6.6a1.1,1.1,0,0,1-1,1,1,1,0,0,1-1-1A1,1,0,0,1,8,5.5,1.1,1.1,0,0,1,9,6.6" transform="translate(0 -0.1)" style="fill:#fdb913"/><path d="M12.4,6.6a1.1,1.1,0,0,1-1,1,1.1,1.1,0,0,1-1.1-1,1.1,1.1,0,0,1,1.1-1.1,1.1,1.1,0,0,1,1,1.1" transform="translate(0 -0.1)" style="fill:#fdb913"/></svg>
      <h5>불편신고목록</h4>
    </a>
    <a href="" class="d-flex al-cnt">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M7.6,10.6c-.3,0-.5,0-.6-.2L4.9,8.5a.8.8,0,0,1,0-1.2.8.8,0,0,1,1.2-.1L7.5,8.6l2.6-2.5a.7.7,0,0,1,1.2,0,.9.9,0,0,1,0,1.2L8.2,10.4A.7.7,0,0,1,7.6,10.6Z" transform="translate(0)" style="fill:#fdb913"/><path d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.7A6.3,6.3,0,1,0,14.3,8,6.3,6.3,0,0,0,8,1.7Z" transform="translate(0)" style="fill:#fdb913"/><rect width="16" height="16" style="fill:none"/></svg>
      <h4>서비스 신청</h4>
    </a>
    <a href="" class="d-flex al-cnt">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.5" height="14.5" viewBox="0 0 16.5 14.5"><defs><clipPath id="clip-path" transform="translate(0.2 0.3)"><rect width="16" height="14" style="fill:none"/></clipPath></defs><g style="clip-path:url(#clip-path)"><path d="M3.7,13.2h8.6a2.8,2.8,0,0,0,2.9-2.8V3.6A2.8,2.8,0,0,0,12.3.8H3.7A2.8,2.8,0,0,0,.8,3.6v6.8A2.8,2.8,0,0,0,3.7,13.2Z" transform="translate(0.2 0.3)" style="fill:none;stroke:#fdb913;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.0999999046325684px"/><line x1="5.3" y1="6.5" x2="5.3" y2="10.1" style="fill:none;stroke:#fdb913;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.0999999046325684px"/><line x1="8.4" y1="4.8" x2="8.4" y2="10.1" style="fill:none;stroke:#fdb913;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.0999999046325684px"/><line x1="11.5" y1="7.6" x2="11.5" y2="10.1" style="fill:none;stroke:#fdb913;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.0999999046325684px"/></g></svg>
      <h4>데이터수집</h4>
    </a>
    -->
  </div>

</template>

<script>
export default {
  name: "SideMenuAdmin",
  methods: {
    openSubMenu( subMenu ){
      const sub_menu = document.querySelectorAll(".sub_menu");
      sub_menu[subMenu].classList.toggle('off');
    },
    checkMenu( path ){
      path = path.split('/');
      const ary = [
        ["company", "member"],
        ["manager"]
          /*
        ["smartroom"],
        [],

        */

      ];
      let findKey = 0;
      ary.forEach((word, key)=>{
        if( word.find(e => e === path[1]) !== undefined ){
          findKey = key;
        }
      })
      this.openSubMenu(findKey);
    }

  },
  mounted() {
    this.checkMenu( this.$route.path );
  }
}
</script>

<style scoped>
.off {
  display: none;
  transition: transform 1s;
}
.adm_nav .nav_signIn,
.side_menu_wr .current_page {
  background-color: #098eff;
}
.menu_icon * {
  fill: #098eff !important;
}
</style>
